const state = () => ({
  isFlutterReady: false,
  isFlutterBridgeReady: false,
  flutterQueue: []
});

const getters = {
  isFlutterReady(state) {
    return state.isFlutterReady;
  },
  flutterQueue(state) {
    return state.flutterQueue;
  }
};

const mutations = {
  setIsFlutterReady(state, payload) {
    state.isFlutterReady = payload;
  },
  addFlutterQueue(state, payload) {
    const queueTmp = state.flutterQueue;
    queueTmp.push(payload);
    state.flutterQueue = queueTmp;
  },
  shiftFlutterQueue(state) {
    const queueTmp = state.flutterQueue;
    queueTmp.shift();
    state.flutterQueue = queueTmp;
  },
  setIsFlutterBridgeReady(state, payload) {
    state.isFlutterBridgeReady = payload;
  }
};

const actions = {
  setIsFlutterReady({ commit }, payload) {
    commit('setIsFlutterReady', payload);
  },
  addFlutterQueue({ commit }, payload) {
    commit('addFlutterQueue', payload);
  },
  shiftFlutterQueue({ commit }, payload) {
    commit('shiftFlutterQueue', payload);
  }
};

export const flutter = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
